import React from 'react';
import messages from '../../../../const/messages';
import ValidationForm from '../../../forms/ValidationForm';
import PopupButtons from '../../../components/Popup/PopupButtons';
import { okButtonClass } from '../../../../const/popupButtonClasses';

class ProfileForm extends React.Component {
    validateFirstName = ({ firstName }) => {
        return !/^[a-zA-Z- ]+$/.test(firstName) ? messages.userNameNotAllowedSymbols : null;
    }

    validateLastName = ({ firstName: lastName }) => {
        return !/^[a-zA-Z- ]+$/.test(lastName) ? messages.userNameNotAllowedSymbols : null;
    }

    ok = ({ firstName, lastName, companyName }) => {
        this.props.updateProfile(firstName, lastName, companyName);
    }

    render() {
        const { firstName, lastName, companyName, email } = this.props;

        return <div className="profile-form">
            <div className="form-sub-header">
                User info
            </div>
            <ValidationForm
                inputs={[
                    {
                        name: 'email',
                        label: 'Email',
                        disabled: true,
                        value: email,
                    },
                    {
                        name: 'firstName',
                        label: 'First name',
                        value: firstName,
                        applyOnEnter: true,
                        rules: [this.validateFirstName],
                        autoComplete: 'off',
                    },
                    {
                        name: 'lastName',
                        label: 'Last name',
                        value: lastName,
                        rules: [this.validateLastName],
                        applyOnEnter: true,
                        autoComplete: 'off',
                    },
                    {
                        name: 'companyName',
                        label: 'Company',
                        value: companyName,
                        applyOnEnter: true,
                        autoComplete: 'off',
                    },
                ]}
                buttons={[
                    {
                        key: 'ok',
                        label: 'Save Profile',
                        action: this.ok,
                        className: `${okButtonClass} big only-btn`
                    }
                ]} />
        </div>;
    }
}

export default ProfileForm;